const clientsTypes = {
    GET_CLIENTS_PENDING: "GET_CLIENTS_PENDING",
    GET_CLIENTS_SUCCESS: "GET_CLIENTS_SUCCESS",
    GET_CLIENTS_ERROR: "GET_CLIENTS_ERROR",
    CLEAR_CLIENTS: "CLEAR_CLIENTS",

    PUT_CLIENT_PENDING: "PUT_CLIENT_PENDING",
    PUT_CLIENT_SUCCESS: "PUT_CLIENT_SUCCESS",
    PUT_CLIENT_ERROR: "PUT_CLIENT_ERROR",

    CHANGE_CHOSEN_CLIENTS:"CHANGE_CHOSEN_CLIENTS",
    CLEAR_CHOSEN_CLIENTS:"CLEAR_CHOSEN_CLIENTS",

    CHANGE_PARAMS:"CHANGE_PARAMS",
    CHANGE_CLIENTS_PAGE:"CHANGE_CLIENTS_PAGE",
}

export default clientsTypes
